import { type SelectorDetails } from "@/modules/ethereum/external-plugin/model/SelectorDetails";

export type DappInfos = { selectorDetails: SelectorDetails; abi: object[] };
